import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { DomSanitizer } from '@angular/platform-browser';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class LatestEpisodeService {

    constructor(
        private http : HttpClient,
        private sanitizer: DomSanitizer
    ) {}

    // getAnalyseVideos_old(maxResults = 4) {
    //     const url = `https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&maxResults=${maxResults}&playlistId=${this.YOUTUBE_ANALYZE_PLAYLIST_ID}&key=${this.YOUTUBE_API_KEY}`;
        
    //     return this.http.get<any>(url).pipe(
    //       map(response =>
    //         response.items.map((item: any) => ({
    //           title: item.snippet.title,
    //           date: item.snippet.publishedAt,
    //           badge: 'ANALYSE',
    //           videoId: item.snippet.resourceId.videoId,
    //           thumbnail: item.snippet.thumbnails?.medium?.url || '', 
    //           safeUrl: this.sanitizer.bypassSecurityTrustResourceUrl(
    //             `https://www.youtube.com/embed/${item.snippet.resourceId.videoId}`
    //           )
    //         }))
    //       )
    //     );
    // }  

    getAnalyseVideos(maxResults = 4) {
      const url = `${environment.API_URL}/youtube/analyse?maxResults=${maxResults}`;
      
      return this.http.get<any[]>(url, { headers: {'Authorization': `Bearer ${environment.API_TOKEN}`}}).pipe(
        map(response =>
          response.map(item => ({
            ...item,
            safeUrl: this.sanitizer.bypassSecurityTrustResourceUrl(item.embedUrl)
          }))
        )
      );
    }
    
    
    
    // getLatestVideos_old(maxResults = 5) {
    //     const analyseUrl = `https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&maxResults=${maxResults}&playlistId=${this.YOUTUBE_ANALYZE_PLAYLIST_ID}&key=${this.YOUTUBE_API_KEY}`;
    //     const interviewUrl = `https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&maxResults=${maxResults}&playlistId=${this.YOUTUBE_INTERVIEW_PLAYLIST_ID}&key=${this.YOUTUBE_API_KEY}`;
      
    //     const analyse$ = this.http.get<any>(analyseUrl).pipe(
    //         map(response =>
    //           response.items
    //             .filter((item: any) => item.snippet?.resourceId?.kind === 'youtube#video')
    //             .map((item: any) => ({
    //               title: item.snippet.title,
    //               date: item.snippet.publishedAt,
    //               badge: 'ANALYSE',
    //               videoId: item.snippet.resourceId.videoId,
    //               thumbnail: item.snippet.thumbnails?.medium?.url || '',
    //               safeUrl: this.sanitizer.bypassSecurityTrustResourceUrl(
    //                 `https://www.youtube.com/embed/${item.snippet.resourceId.videoId}`
    //               )
    //             }))
    //         )
    //     );          
      

    //     const interview$ = this.http.get<any>(interviewUrl).pipe(
    //         map(response =>
    //           response.items
    //             .filter((item: any) => item.snippet?.resourceId?.kind === 'youtube#video')
    //             .map((item: any) => ({
    //               title: item.snippet.title,
    //               date: item.snippet.publishedAt,
    //               badge: 'INTERVIEW',
    //               videoId: item.snippet.resourceId.videoId,
    //               thumbnail: item.snippet.thumbnails?.medium?.url || '',
    //               safeUrl: this.sanitizer.bypassSecurityTrustResourceUrl(
    //                 `https://www.youtube.com/embed/${item.snippet.resourceId.videoId}`
    //               )
    //             }))
    //         )
    //     );
      
    //     return forkJoin([analyse$, interview$]).pipe(
    //       map(([analyseVideos, interviewVideos]) =>
    //         [...analyseVideos, ...interviewVideos]
    //           .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime())
    //       )
    //     );
    // }

    getLatestVideos(maxResults = 5): Observable<any[]> {
      const url = `${environment.API_URL}/youtube/latest-analyse-interview?maxResults=${maxResults}`;
    
      return this.http.get<any[]>(url, { headers: {'Authorization': `Bearer ${environment.API_TOKEN}`}}).pipe(
        map(response =>
          response.map(item => ({
            ...item,
            safeUrl: this.sanitizer.bypassSecurityTrustResourceUrl(item.embedUrl)
          }))
        )
      );
    }    
      
}